const Splash = () => {
  //Buraya bir yükleme animasyonu veya benzeri bir içerik eklenebilir
  return (
    <div className="flex min-h-screen w-full flex-col justify-center items-center bg-white p-5">
      <img
        src={"/the_sezar_logo.png"}
        alt="The Sezar Logo"
        className="object-contain mb-2"
        draggable={false}
      />
    </div>
  );
};

export default Splash;
